module.exports = __webpack_public_path__ + "img/not-authorized.388ffe46.png";